import { createRouter, createWebHistory } from 'vue-router';

import authentication from '@/routes/authentication';
import dashboard from '@/routes/dashboard';

export default (store) =>
{
    const routes = [].concat(authentication, dashboard);

    const router = createRouter({
        history: createWebHistory(),
        routes: routes,
        linkActiveClass: 'active',
    });

    router.beforeEach((to, from, next) =>
    {
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

        if (requiresAuth)
        {
            if (store.getters && store.getters.isAuthenticated)
            {
                next();
            }
            else
            {
                next('/auth/login');
            }
        }
        else
        {
            next();
        }
    });

    return router;
};
